export default {
  submitting: false,
  accountDataFilters: {
    Customer_Id: null,
    Acct_ID: null,
    Acct_Name: null
  },
  nextPaginationKey: '',
  isBulkRequest: false,
  request: {
    Acct_ID: null,
    Acct_Owner: null,
    Financial_Owner: null,
    WBS_Code: null,
    Customer_Name: null,
    Managed_Services: null,
    Acct_Purpose: null,
    Acct_Type: null,
    Provided_Commercial_Service: null,
    Customer_Console_Access: null,
    // AWS_Support_Type: null,
    // Opportunity_Id: null,
    // Internal_Vs_Saas: null,
    // Direct_Vs_Indirect_Access: null,
    // New_Workload: null,
    // SFDC_ID: null,
    // DXC_Services: null,
    // Architecture_Diagram: null,
    // Confirm_Correctness: null,
    Requestor_Id: null
  },
  attestationHeaders: [
    {
      sortable: false,
      text: 'Actions',
      value: 'action'
    },
    {
      sortable: false,
      text: 'Account ID',
      value: 'Acct_ID'
    },
    {
      sortable: false,
      text: 'Accout Name',
      value: 'Acct_Name'
    },
    {
      sortable: false,
      text: 'Customer Name',
      value: 'Customer_Name'
    },
    {
      sortable: false,
      text: 'Status',
      value: 'Status'
    },
    {
      sortable: false,
      text: 'Date Submitted',
      value: 'Created_At'
    }
  ],
  bulkAttestationHeaders: [
    {
      sortable: false,
      text: 'Account ID',
      value: 'Account_ID'
    },
    {
      sortable: false,
      text: 'Status',
      value: 'Status'
    }
  ],
  attestationAccounts: [],
  selectedAccountForAttestation: null,
  loadingAccountData: false,
  fileData: [],
  masterpayerRequest: [],
  masterpayerRequestLoading: true
}
